import { SignIn } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';
import { useTheme } from '@/components/ThemeProvider/ThemeProvider';

export const Login = () => {
  const { theme } = useTheme();

  const isDark =
    theme === 'dark' ||
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <SignIn
        routing="path"
        path="/login"
        signUpUrl="/signup"
        appearance={{
          baseTheme: isDark ? dark : undefined,
          variables: {
            colorPrimary: '#3b82f6',
            colorBackground: isDark ? '#141b2d' : '#ffffff',
          },
        }}
      />
    </div>
  );
};
